import { z } from 'zod';

/**
 * Force-Logout Event Contract
 *
 * Pushed via the notifications service's existing SSE infrastructure
 * (tms-api-notifications) to immediately sign a user's open browser tabs
 * out after an admin disables their Cognito account. Cognito remains the
 * source of truth — this is a best-effort UX signal only.
 */

export const ForceLogoutReasonSchema = z.enum([
  'ACCOUNT_DISABLED',
  'ACCOUNT_DELETED',
  'SESSION_REVOKED',
]);
export type ForceLogoutReason = z.infer<typeof ForceLogoutReasonSchema>;

/** Body sent by tms-api-onboarding to POST /notifications/api/v1/notifications/force-logout */
export const ForceLogoutRequestSchema = z.object({
  username: z.string().min(1).describe('Cognito username \u2014 matches the dedicated force-logout SSE stream routing key'),
  reason: ForceLogoutReasonSchema,
});
export type ForceLogoutRequest = z.infer<typeof ForceLogoutRequestSchema>;

/** SSE frame payload delivered to the browser (data: { type: 'FORCE_LOGOUT', ... }) */
export const ForceLogoutEventSchema = z.object({
  type: z.literal('FORCE_LOGOUT'),
  reason: ForceLogoutReasonSchema,
  timestamp: z.string(),
});
export type ForceLogoutEvent = z.infer<typeof ForceLogoutEventSchema>;
